module.exports = __webpack_public_path__ + "static/media/W19-0046_299_Mama_Cheese_Desktop_2396x1473_fr.3052e38f.jpg";